import { render, staticRenderFns } from "./AppContentQuestionMemberSuggest.vue?vue&type=template&id=2a4ffd3e&scoped=true&"
import script from "./AppContentQuestionMemberSuggest.vue?vue&type=script&lang=js&"
export * from "./AppContentQuestionMemberSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ffd3e",
  null
  
)

export default component.exports